import { render, staticRenderFns } from "./EventWorkflowManager.vue?vue&type=template&id=bdd74bce&scoped=true&"
import script from "./EventWorkflowManager.vue?vue&type=script&lang=js&"
export * from "./EventWorkflowManager.vue?vue&type=script&lang=js&"
import style0 from "./EventWorkflowManager.vue?vue&type=style&index=0&id=bdd74bce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd74bce",
  null
  
)

export default component.exports